import styled from '@emotion/styled';
import { spacing } from 'components/core/theme';
import { mediaMobile } from 'components/core/theme/breakpoints';

export const LoadingIndicator = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  backdrop-filter: blur(20px);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${mediaMobile} {
    padding: 2rem;
  }
`;

export const InnerContent = styled.div`
  margin: auto;
  max-width: 768px;
  padding-bottom: ${spacing.s};
`;

export const ContentWrapper = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
  justify-items: center;
  justify-self: center;
  max-width: 760px;
  width: 100%;
  margin: auto;

  ${mediaMobile} {
    padding: 12px;
  }
`;

export const H2 = styled.h2`
  font-size: 2rem;
  line-height: 1.2;
  font-weight: 400;
`;

export const H4 = styled.h4`
  font-size: 1.25rem;
  line-height: 1.235;
`;

export const Legalese = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  padding-bottom: 16px;
  color: #0009;
`;

export const ButtonWrapper = styled.div`
  text-align: center;
`;

export const ModalContent = styled.div`
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 6% auto;
  width: 60%;
  border-radius: 60px;
  padding: 10px 10px 60px;

  ${mediaMobile} {
    width: 95%;
  }
`;

export const Example = styled.span`
  color: red;
`;
